import { uniq } from 'lodash';

export const capitalizeFirstLetter = (s: string) => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();

export const separateStringsByDelimiter = (strings: (string | null | undefined)[] = [], delimiter: string = ',') => {
  return uniq(strings.filter((v) => v)).join(delimiter);
};

export const unCamelCase = (str: string) =>
  str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs) => (ofs ? ' ' : '') + $.toLowerCase());

export function capitalize(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
